import React, { useEffect, useState } from "react";
import qs from "query-string";

import FormViewer from "../FormViewer";
import block from 'bem-css-modules';
import { initiateSessionLayer } from "../../util/sessionLayer";
import styles from "./FormClient.module.scss";
import { getFieldFromPushData, trackEvent, getPublicBucketUrl } from "../../util/functions";

const FormClient = (props: { uuid: string; }) => {
  const { uuid } = props;
  const [ formData, setFormData ] = useState();
  const [firstInteraction, setFirstInteraction] = useState(true);
  const b = block(styles);
  const { sessionLayer } = window;

  initiateSessionLayer(formData);

  useEffect(() => {
    const params = qs.parse(window.location.search);
    Object.keys(params)?.forEach((key) => {
      const value = params[key];
      if (key.startsWith("crm_field_") && typeof value === "string" && value.trim() !== "") {
        const field = key.replace("crm_field_", "");
        sessionLayer && !getFieldFromPushData(field) && sessionLayer.pushToSession(field, value)
      }
    });
  }, [sessionLayer])

  useEffect(() => {
    const handleInteraction = (event: MouseEvent) => {
      if (!firstInteraction) return;

      const target = event.target as HTMLElement;
      if (target.closest(".khc-formclient")) {
        trackEvent("formClient.firstInteraction");
        setFirstInteraction(false);
      }
    };

    // Attach a single click event listener to a common ancestor
    document.addEventListener("click", handleInteraction);

    return () => {
      // Remove the click event listener when the component unmounts
      document.removeEventListener("click", handleInteraction);
    };
  }, [firstInteraction]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const basePublicBucketUrl = await getPublicBucketUrl();
  
        if (uuid) {
          const response = await fetch(`${basePublicBucketUrl}/local-json/${uuid}.json`);
          const res = await response.json();
          setFormData(res.formData);
          trackEvent("formClient.loaded");
        }
      } catch (_err) {
        console.log(_err);
      }
    };
  
    fetchData();
  }, [uuid]);

  return (
    <>
      {formData && 
        <div className={`khc-formclient ${b()}`}>
          <FormViewer formData={formData} />
        </div>
      }
    </>
  )
}

export default FormClient;